import React, { useState } from 'react';
import { useFormContext } from 'react-hook-form';

import { FormBlock, StepProps } from '@/widgets/ServiceFormTemplate';

import { ConfirmationOfApplication } from '@/features/ui';

import { ConditionView, StepControlPanel } from '@/shared/ui';

import { Loader } from '@/shared/ui';

import { MissingPersonFormData } from '../../model/types';

import { ApplicantPersonalDataPreview } from './ApplicantPersonalData';
import { ERDRInformationPreview } from './ERDRInfo';
import { MissingPersonDisappearanceInfoPreview } from './InformationAboutDisappearance';
import { MissingPersonAddressStepPreview } from './MissingPersonAddress';
import { MissingPersonPersonalDataPreview } from './MissingPersonPersonalData';
import { PersonalFeaturesPreview } from './PersonalFeatures';

export interface DataPreviewProps {
  generatePDF?: (formData: MissingPersonFormData) => Promise<void>;
  submitForm?: (formData: MissingPersonFormData) => Promise<void>;
  shouldBeAbleToUpdateProfile: boolean;
}

export const DataPreview: React.FC<StepProps<DataPreviewProps>> = ({
  next,
  prev,
  generatePDF,
  submitForm,
  shouldBeAbleToUpdateProfile,
}) => {
  const { getValues, watch } = useFormContext<MissingPersonFormData>();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const confirmEnteredDataCorrect = watch('confirmEnteredDataCorrect');

  const handleNextStep = (): void => {
    setIsLoading(true);

    generatePDF?.(getValues() as MissingPersonFormData).then(() => {
      submitForm?.(getValues() as MissingPersonFormData)
        .then(() => next())
        .catch(console.error)
        .finally(() => setIsLoading(false));
    });
  };

  return (
    <ConditionView if={!isLoading} else={<Loader />}>
      <FormBlock title="Підтвердження даних" className="form-block__data-preview">
        <MissingPersonPersonalDataPreview />
        <PersonalFeaturesPreview />
        <MissingPersonAddressStepPreview />
        <MissingPersonDisappearanceInfoPreview />
        <ERDRInformationPreview />
        <ApplicantPersonalDataPreview />
      </FormBlock>
      <ConfirmationOfApplication shouldBeAbleToUpdateProfile={shouldBeAbleToUpdateProfile} />
      <StepControlPanel prev={prev} next={handleNextStep} disabledNext={!confirmEnteredDataCorrect} />
    </ConditionView>
  );
};
